export default __webpack_public_path__ + "static/default-cover-image-08a4301fea415d4f961496d67f6f3098.jpg";